module.exports = __webpack_public_path__ + "static/media/ERAS.cc45f78b.TTF";